import React, { useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";
import AdminRoutes from "./routes/AdminRoutes";
import { useAuth } from "./contexts/AuthContext";

const App: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();

  // Hide the loading animation when React has mounted
  useEffect(() => {
    const loadingElement = document.getElementById('loading');
    if (loadingElement) {
      loadingElement.style.display = 'none';
    }
  }, []);

  // Show loading state while checking authentication
  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      Authentication in progress...
    </div>; // Or your loading component
  }

  return isAuthenticated ? <AdminRoutes isAuthenticated={isAuthenticated} /> : <AppRoutes isAuthenticated={isAuthenticated} />;
};

export default App;
